/**
 * Format a minor-unit amount (kobo/cents) as a currency string.
 * payment-service stores all monetary amounts in minor units.
 */
export function formatMinor(amount: number, currency = 'NGN'): string {
  const symbol = currency === 'NGN' ? '₦' : currency === 'USD' ? '$' : '';
  const value = (amount / 100).toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${value}`;
}
